import { icon } from './Icon';

export interface RecModalProps {
  title: string;
  meta?: string;
  items: string[];
  recTitle: string;
  closeLabel: string;
  description?: string;
  whatLabel?: string;
  directionLabel?: string;
  directionClass?: 'up' | 'down' | 'neutral';
  directionIcon?: string;
}

/** Modal listing suggested improvement ideas/steps for a KPI, chart, or panel. */
export function RecModal(props: RecModalProps): string {
  const { title, meta, items, recTitle, closeLabel, description, whatLabel, directionLabel, directionClass, directionIcon } = props;
  const steps = items.map((s) => `<li>${s}</li>`).join('');
  const meaning = description
    ? `<div class="modal-meaning"><span class="mm-what">${whatLabel ?? ''}</span> ${description}${directionLabel ? ` <span class="dir-badge ${directionClass}">${directionIcon ? icon(directionIcon, 'icon icon-xs') : ''} ${directionLabel}</span>` : ''}</div>`
    : '';
  return `
  <div class="modal-backdrop" data-close>
    <div class="modal" role="dialog" aria-modal="true" aria-label="${title}">
      <div class="modal-head">
        <span class="modal-ic">${icon('lightbulb')}</span>
        <div class="modal-titles">
          <h2>${title}</h2>
          ${meta ? `<p>${meta}</p>` : ''}
        </div>
        <button class="iconbtn modal-close" data-close aria-label="${closeLabel}" title="${closeLabel}">${icon('x')}</button>
      </div>
      ${meaning}
      <h3 class="modal-sub">${recTitle}</h3>
      <ol class="rec-list">${steps}</ol>
    </div>
  </div>`;
}
